var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentUser)?_c('div',{staticClass:"row section-style text-center",attrs:{"id":"section-newsletter"}},[_c('email-subscribe-form',{attrs:{"loading":_vm.loading},on:{"submit":_vm.subscribe}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }